'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const dagCBOR = require('ipld-dag-cbor');

const dagPB = require('ipld-dag-pb');

const ipldRaw = require('ipld-raw');

const CID = require('cids');

const multihash = require('multihashes');

const configure = require('../lib/configure');

const multipartRequest = require('../lib/multipart-request');

const toUrlSearchParams = require('../lib/to-url-search-params');

const anySignal = require('any-signal');

const AbortController = require('abort-controller');

const multicodec = require('multicodec');

module.exports = configure((api, opts) => {
  const formats = {
    [multicodec.DAG_PB]: dagPB,
    [multicodec.DAG_CBOR]: dagCBOR,
    [multicodec.RAW]: ipldRaw
  };
  const ipldOptions = opts && opts.ipld || {};
  const configuredFormats = ipldOptions && ipldOptions.formats || [];
  configuredFormats.forEach(format => {
    formats[format.codec] = format;
  });
  return async (dagNode, options = {}) => {
    if (options.cid && (options.format || options.hashAlg)) {
      throw new Error('Failed to put DAG node. Provide either `cid` OR `format` and `hashAlg` options');
    } else if (options.format && !options.hashAlg || !options.format && options.hashAlg) {
      throw new Error('Failed to put DAG node. Provide `format` AND `hashAlg` options');
    }

    if (options.cid) {
      const cid = new CID(options.cid);
      options = _objectSpread(_objectSpread({}, options), {}, {
        format: cid.codec,
        hashAlg: multihash.decode(cid.multihash).name
      });
      delete options.cid;
    }

    options = _objectSpread({
      format: 'dag-cbor',
      hashAlg: 'sha2-256',
      inputEnc: 'raw'
    }, options);
    const number = multicodec.getNumber(options.format);
    let format = formats[number];

    if (!format) {
      if (opts && opts.ipld && opts.ipld.loadFormat) {
        format = await opts.ipld.loadFormat(options.format);
      }

      if (!format) {
        throw new Error('Format unsupported - please add support using the options.ipld.formats or options.ipld.loadFormat options');
      }
    }

    if (!format.util || !format.util.serialize) {
      throw new Error('Format does not support utils.serialize function');
    }

    const serialized = format.util.serialize(dagNode); // allow aborting requests on body errors

    const controller = new AbortController();
    const signal = anySignal([controller.signal, options.signal]);
    const res = await api.post('dag/put', _objectSpread({
      timeout: options.timeout,
      signal,
      searchParams: toUrlSearchParams(options)
    }, await multipartRequest(serialized, controller, options.headers)));
    const data = await res.json();
    return new CID(data.Cid['/']);
  };
});